<h4 class="consents-section-title">{{ 'members.consents.title' | translate }}</h4>
<div class="consents-section-intro">{{
    consentsTranslations?.getConsentTranslation('general_intro') ||
    ('members.consents.intro' | translate)
  }}
</div>
@if (consentKeys.length > 1) {
  <button
      class="btn btn-raised btn-primary consents-select-all-button"
      type="button"
      (click)="selectAll()">
    {{ 'members.consents.accept_all_consents' | translate }}
  </button>
}
@for (key of consentKeys; track key) {
  <div
      class="form-group consent-{{key}}"
      [ngClass]="{'has-error': !!formGroup.get(key)?.errors }">
    <label class="control-label consent-title">{{ consentsTranslations?.getConsentTranslation(key, 'title') }}</label>
    <div class="consent-question">
      <div [innerHTML]="consentsTranslations?.getConsentTranslation(key)"></div>
      @if (consentsTranslations?.isReadmoreAvailable(key)) {
        <div class="consent-readmore-button"
             (click)="openModal(readmoreModal, {class: 'modal-lg'})">
          <i class="icon icon-info"></i>
        </div>
      }
    </div>
    <div appConsentAnswer class="consent-answer btn-radio-group" btnRadioGroup [formControl]="$any(formGroup.get(key))">
      <label [btnRadio]="$any(true)" class="btn-radio consent-yes">
        <span class="consent-answer-text">
          @if (consentsTranslations?.getConsentTranslation(key, '__yes__')) {
            {{ consentsTranslations?.getConsentTranslation(key, '__yes__') }}
          } @else {
            {{ 'generic.yes_word' | translate }}
          }
        </span>
      </label>
      <label [btnRadio]="$any(false)" class="btn-radio consent-no">
        <span class="consent-answer-text">
          @if (consentsTranslations?.getConsentTranslation(key, '__no__')) {
            {{ consentsTranslations?.getConsentTranslation(key, '__no__') }}
          } @else {
            {{ 'generic.no_word' | translate }}
          }
        </span>
        @if (consentsTranslations?.getConsentTranslation(key, 'no_alt')) {
          <span class="consent-alt-no">
            {{ consentsTranslations?.getConsentTranslation(key, 'no_alt') }}
          </span>
        }
      </label>
    </div>
    <ng-template #readmoreModal>
      <div class="modal-header">
        <h4 class="modal-title pull-left">{{ consentsTranslations?.getConsentTranslation(key, 'title') }}</h4>
      </div>
      <div class="modal-body" [innerHTML]="consentsTranslations?.getConsentTranslation(key, 'read_more')"></div>
      <div class="modal-footer">
        <button type="button" class="btn btn-raised btn-primary" (click)="hideModal()">
          {{ 'generic.close' | translate }}
        </button>
      </div>
    </ng-template>
  </div>
}
<ng-content/>
<div class="consents-section-summary">{{
    consentsTranslations?.getConsentTranslation('general_summary') ||
    ('members.consents.summary' | translate)
  }}
</div>
